import {
  ApiClientError,
  GetProfileDeviceLicenses,
} from '@raydiant/api-client-js';
import raydiant from '../clients/miraClient';
import useProtectedQuery from './useProtectedQuery';
import { keys } from '../queryClient';

export default function useProfileDeviceLicenses() {
  const query = useProtectedQuery<GetProfileDeviceLicenses, ApiClientError>(
    keys.profileDeviceLicenses(),
    () => raydiant.getProfileDeviceLicenses(),
  );

  return query;
}
